import React, { lazy, memo } from 'react';
export const TestimonialsSection = memo(function TestimonialsSection() {
  const testimonials = [{
    name: 'Nicolás R.',
    location: 'Córdoba',
    time: '11:42',
    avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
    message: 'bro te juro que cambié un tomacorriente yo solo por primera vez en mi vida 😂 el técnico me cobraba $24000 por eso. tardé 15 minutos siguiendo el tomo 2. no puedo creer que antes le pagaba a alguien por esto 🤦'
  }, {
    name: 'Martín G.',
    location: 'Buenos Aires',
    time: '09:15',
    avatar: 'https://randomuser.me/api/portraits/men/45.jpg',
    message: 'che, yo era de los que ni tocaba un enchufe por miedo jaja. leí el tomo 1 en una tarde y ya entendí todo. esta semana cambié dos llaves de luz y arreglé un velador que tenía roto hace meses. una locura lo que me estaba perdiendo 😅🙌'
  }, {
    name: 'Diego F.',
    location: 'Rosario',
    time: '20:33',
    avatar: 'https://randomuser.me/api/portraits/men/67.jpg',
    message: 'loco el diferencial me saltaba hace semanas y llamé al técnico dos veces. $36000 entre las dos visitas. con el tomo 3 entendí qué pasaba y lo resolví en 20 minutos. dos visitas de técnico en una semana para algo tan simple... 😤'
  }, {
    name: 'Sebastián M.',
    location: 'Mendoza',
    time: '14:20',
    avatar: 'https://randomuser.me/api/portraits/men/22.jpg',
    message: 'hice el checklist del bono en mi casa y encontré 4 cosas que estaban mal y ni lo sabía jaja. las arreglé todas yo mismo. mi viejo que es albañil no lo podía creer 😂 dice que ojalá hubiera tenido esto cuando era joven'
  }, {
    name: 'Lucas P.',
    location: 'La Plata',
    time: '17:55',
    avatar: 'https://randomuser.me/api/portraits/men/54.jpg',
    message: 'dudé mucho porque nunca compré nada digital. pero con la garantía dije bueno me arriesgo. la primera semana ya resolví 3 cosas que tenía pendientes hace meses. me ahorré fácil $90000 en técnicos. ojalá lo hubiera comprado antes 🙏'
  }, {
    name: 'Carlos T.',
    location: 'Santa Fe',
    time: '08:47',
    avatar: 'https://randomuser.me/api/portraits/men/78.jpg',
    message: 'acabo de instalar una toma nueva en el garage yo solo 🔧 antes eso para mí era imposible, llamaba al técnico sin dudarlo. ahora entiendo lo que estoy haciendo y no le tengo más miedo. el material está buenísimo, muy fácil de seguir 🤙'
  }];
  return <section className="py-16 bg-gray-50 border-t border-gray-200 overflow-hidden" data-id="element-210">
      {/* Header */}
      <div className="text-center px-4 mb-6" data-id="element-211">
        <div className="inline-block bg-green-50 text-green-600 px-5 py-1.5 rounded-full font-black text-[11px] uppercase tracking-widest mb-4 border border-green-200" data-id="element-212">
          ✅ LO QUE DICEN LOS QUE YA LO TIENEN
        </div>
        <h2 className="text-[24px] md:text-4xl font-black text-gray-900 leading-tight" data-id="element-213">
          Resultados reales de personas{' '}
          <span className="text-blue-600" data-id="element-214">como vos:</span>
        </h2>
        <p className="text-gray-500 text-[11px] mt-3 max-w-sm mx-auto" data-id="element-215">
          * Los testimonios reflejan experiencias individuales. Los resultados
          pueden variar según el nivel de dedicación de cada persona.
        </p>
      </div>

      {/* Hint deslizar mobile */}
      <div className="flex items-center justify-center gap-2 mb-4 md:hidden" data-id="element-216">
        <span className="text-gray-500 text-[11px]" data-id="element-217">
          👈 Deslizá para ver más
        </span>
      </div>

      {/* Carrusel */}
      <div className="relative w-full" data-id="element-218">
        <div className="absolute left-0 top-0 bottom-0 w-8 md:w-16 bg-gradient-to-r from-gray-50 to-transparent z-10 pointer-events-none" data-id="element-219" />
        <div className="absolute right-0 top-0 bottom-0 w-8 md:w-16 bg-gradient-to-l from-gray-50 to-transparent z-10 pointer-events-none" data-id="element-220" />

        <div className="flex gap-4 px-4 py-2 overflow-x-auto scroll-smooth scrollbar-hide" style={{
        scrollSnapType: 'x mandatory',
        WebkitOverflowScrolling: 'touch'
      }} data-id="element-221">
          {testimonials.map((t, index) => <div key={index} className="flex-shrink-0 w-[270px] bg-[#111B21] rounded-2xl overflow-hidden border border-gray-300 shadow-md" style={{
          scrollSnapAlign: 'start'
        }} data-id="element-222">
              {/* Header WhatsApp */}
              <div className="bg-[#202C33] px-3 py-2.5 flex items-center gap-2.5" data-id="element-223">
                <img src={t.avatar} alt={t.name} loading="lazy" decoding="async" className="w-8 h-8 rounded-full object-cover flex-shrink-0" data-id="element-224" />
                <div className="flex-1 min-w-0" data-id="element-225">
                  <p className="text-white font-bold text-[12px] leading-tight" data-id="element-226">
                    {t.name}
                  </p>
                  <p className="text-gray-400 text-[10px]" data-id="element-227">📍 {t.location}</p>
                </div>
                <span className="text-gray-500 text-[10px]" data-id="element-228">{t.time}</span>
              </div>

              {/* Mensaje */}
              <div className="bg-[#0B141A] p-3" data-id="element-229">
                <div className="flex justify-end" data-id="element-230">
                  <div className="bg-[#005C4B] text-white text-[12px] leading-relaxed px-3 py-2 rounded-xl rounded-tr-sm max-w-[95%] shadow-sm" data-id="element-231">
                    {t.message}
                    <div className="flex items-center justify-end gap-1 mt-1" data-id="element-232">
                      <span className="text-[10px] text-green-300/60" data-id="element-233">
                        {t.time}
                      </span>
                      <svg className="w-3 h-3 text-blue-400" viewBox="0 0 16 11" fill="currentColor" data-id="element-234">
                        <path d="M11.071.653a.5.5 0 0 0-.707 0L4.54 6.477 2.121 4.059a.5.5 0 0 0-.707.707l2.772 2.772a.5.5 0 0 0 .707 0l6.178-6.178a.5.5 0 0 0 0-.707zM14.071.653a.5.5 0 0 0-.707 0L7.54 6.477l-.354-.353-.707.707.707.707a.5.5 0 0 0 .707 0l6.178-6.178a.5.5 0 0 0 0-.707z" data-id="element-235" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
});